/**
 * File entry-track.js.
 * Handles sending Segment events for enrollment and login link clicks
 */

( function() {
  let page, ctaText, ctaEmail = null;
  let emailEntered = false;
  const ctaLocation = window.location.href;

  // add click listener for all enrollment buttons and login links
  page = document.getElementById('page');
  if (page !== null) {
    document.addEventListener( 'click', entryTrack );
  }

  function entryTrack(e) {
    if (e.target && e.target.href && typeof e.target.href.match === 'function') {
      const enrollMatch = e.target.href.match( /(member-?\w*)\.chime\.com\/(signup|enroll)/ );
      const loginMatch = e.target.href.match( /(member-?\w*)\.chime\.com\/(users|link)\/sign_in/ );
      if (enrollMatch || loginMatch) {
        sscmsPreventDefault(e);

        ctaText = e.target.textContent;

        // set event names depending on what was clicked
        if (enrollMatch) {
          let ctaDestination = e.target.href;

          // set button location as hero, bottom, or communication based on cta parents
          let linkLocation = (e.target.closest('.header')) ? 'header' :
          (e.target.closest('.hero, .referral, .landing-page')) ? 'hero' :
          (e.target.closest('.switch')) ? 'bottom' :
          'communication';

          const moduleAttributes
            = getModuleTrackingAttributes(e.target);

          const moduleData = extractModuleData(moduleAttributes);

          const additionalData = [
            ...moduleAttributes,
            { key: 'destination', value: ctaDestination },
            { key: 'label', value: ctaText},
            { key: 'cta_type', value: 'enrollment' }
          ];

          let properties = {
            cta_copy: ctaText,
            location: ctaLocation,
            button_location: linkLocation,
            email_entered: emailEntered,
            email: ctaEmail,
            additional_data: additionalData,
            interaction_details: {
              location: ctaLocation,
              action_detail: ctaText,
            },
          };
          // Pass CTA tapped message to tags.chime.com iframe
          firePostMessageEvent('tags.enter_enrollment_cta_tapped');

          segmentGenericEvent("track", {
            interaction_type: "INTERACTION_TYPE_ENTER_ENROLLMENT_CTA_TAPPED",
            interaction_details: {
              location: ctaLocation,
              action_detail: ctaText
            },
            ...properties
          }, redirect(e.target.href), true);

          // Analytics SDK double fire
          fireAnalyticsEvent(Track.WebItemClicked, {
            unique_id: 'enrollment_cta_tapped',
            label: ctaText,
            element_type: 'ELEMENT_TYPE_BUTTON',
            item_value: ctaDestination,
            item_details: {
              "enrollment_cta_tapped": {
                "module": {
                  ...moduleData,
                },
                "cta_type": 'enrollment',
                "button_location": ctaLocation,
              }
            }
          });
        } else {
          let lpType = (e.target.closest('.landing-page') || e.target.closest('.paid')) ? 'paid' : 'organic';
          let properties = {
            cta_copy: ctaText,
            lp_type: lpType,
          };

          // Pass login link tapped message to tags.chime.com iframe
          firePostMessageEvent('tags.login_link_tapped');

          window.waitForAnalyticsSDK().then(() => {
            fireAnalyticsEvent(Track.WebItemClicked, {
              unique_id: 'login_link_tapped',
              label: ctaText,
              element_type: 'ELEMENT_TYPE_LINK',
              item_details: {
                "login_link_tapped": {
                  "lp_type": lpType
                }
              }
            });
          });

          // Fire segment event
          segmentTrack(e, 'Login Link Tapped', properties);

        }
      }
    }
  }

  function segmentTrack(e, eventName, properties = {}) {
    const callbackUrl = e.target.href;
    const goToUrl = redirect(callbackUrl);

    // trigger segment event
    segment(
      'track',
      eventName,
      properties,
      goToUrl,
      true
    );
  }
} )();
